module.exports = __webpack_public_path__ + "img/Paladin.af8f5ac6.png";